import { useState } from 'react'
import { NavLink, Link } from 'react-router-dom'
const Menu = ({ MenuItem }) => {
   const [menuTab, setMenuTab] = useState(false);
   const isExternal = (url) => url.startsWith('http');
   return (
      <>
         <nav id="cssmenu">
            <div id="head-mobile"></div>
            <div className="menubutton" onClick={() => setMenuTab(!menuTab)}><i class="bi bi-chevron-down"></i></div>

            <ul className={menuTab ? "menutwo active" : "menutwo inactive"}>
               <li className='home_icon'><Link to="/"><i class="bi bi-house-fill"></i></Link></li>
               {MenuItem.map((menu, index) => (
                  <li key={index}>
                    {isExternal(menu.link) ? (
                      <a
                        href={menu.link}
                        target={menu.target || "_blank"}
                        rel="noopener noreferrer"
                      >
                        {menu.label}
                      </a>
                    ) : (
                      <Link to={menu.link}>{menu.label}</Link>
                    )}
        
                    {menu.subMenu && (
                      <ul>
                        {menu.subMenu.map((subMenuList, subIndex) => (
                          <li key={subIndex}>
                            <NavLink to={subMenuList.link}>{subMenuList.label}</NavLink>
                          </li>
                        ))}
                      </ul>
                    )}
                  </li>
                ))}

            </ul>
         </nav>
      </>
   )
}
export default Menu